import { defineStore } from "pinia"
import { readThemePreference, THEME_STORAGE_KEY } from "@/composables/useThemePreference"

export const useLayoutStore = defineStore("layout", {
  getters: {
    // Inside the Erklärung's frame this reads nothing: the frame's storage starts without the reader's
    // drawer state (services/viewHelp/isolation.ts), so the drawer opens full, and the walkthrough's
    // pointer finds its entries by their `nav-<Route>` anchor.
    getNavbarMinimize: () => () => JSON.parse(localStorage.getItem("navbar")),
    getLocale: () => localStorage.getItem("locale"),
    // "system" | "light" | "dark". Validated on read — see `readThemePreference`.
    getTheme: () => readThemePreference(),
  },
  actions: {
    setNavbarMinimize(status) {
      localStorage.setItem("navbar", status)
    },
    setLocale(locale) {
      localStorage.setItem("locale", locale)
    },
    // Persistence only; the live repaint goes through Vuetify in `useThemePreference`.
    setTheme(theme) {
      localStorage.setItem(THEME_STORAGE_KEY, theme)
    },
  },
})
